/**
 * Formatea un número como moneda peruana.
 */
export const formatearMoneda = (monto, moneda = 'PEN') => {
  return new Intl.NumberFormat('es-PE', {
    style:    'currency',
    currency: moneda,
  }).format(monto || 0);
};

/**
 * Formatea una fecha en formato legible.
 */
export const formatearFecha = (fecha) => {
  if (!fecha) return '—';
  return new Date(fecha).toLocaleDateString('es-PE', {
    day:   '2-digit',
    month: '2-digit',
    year:  'numeric',
  });
};

/**
 * Retorna las iniciales de un nombre completo.
 */
export const obtenerIniciales = (nombre, apellido) => {
  return `${nombre?.charAt(0) || ''}${apellido?.charAt(0) || ''}`.toUpperCase();
};

/**
 * Trunca un texto largo.
 */
export const truncarTexto = (texto, limite = 50) => {
  if (!texto) return '—';
  return texto.length > limite ? texto.substring(0, limite) + '...' : texto;
};